
import type { Input, Output } from 'valibot';
import { array, boolean, nullable, number, object, optional, string, transformAsync } from 'valibot';
import { categoryObject } from './category.model';
import { pubUserModel } from './user.model';

export const privatePosts = object({
  view_count: number(),
  post_id: string(),
})

export const privatePostsScheme = transformAsync(privatePosts,
  async (input) => {
    return {
      ...input,
    };
  }
)

export type PrivatePostItem = Input<typeof privatePostsScheme>;


export const commentTable = object({
  id: string(),
  user_id: string(),
  post_id: string(),
  created_at: string(),
  updated_at: string(),
  content: string()
})

export const commentTableWithUser = object({
  ...commentTable.entries,
  public_users: pubUserModel,
})
export type commentTableWithUserScheme = Input<typeof commentTableWithUser>;

const postTableField =
  object({
    id: string(),
    title: string(),
    user_id: string(),
    overview: string(),
    content_path: string(),
    is_public: boolean(),
    is_deleted: boolean(),
    is_story: boolean(),
    created_at: string(),
    updated_at: string(),
    first_published_at: nullable(string()),
    last_edited_at: nullable(string()),
    likes_count: number(),
    thumbnail_path: nullable(string()),
    comments_count: number(),
    display_id: string(),
  })

const publicPostTableField = object({
  user_id: string(),
  title: string(),
  id: string(),
  overview: string(),
  user_name: string(),
  user_main_color: string(),
  user_iconurl: string(),
  categories: nullable(optional(array(categoryObject))),
  is_liked: boolean(),
  is_story: boolean(),
  thumbnail_path: nullable(string()),
  content_path: string(),
  created_at: string(),
  user_display_id: string(),
  updated_at: string(),
  likes_count: number(),
  comments_count: number(),
  first_published_at: nullable(string()),
  last_edited_at: nullable(string()),
  display_id: string(),
})


// notification
export const postSingleWithLikeDBObject = postTableField

export const postMyPage = postTableField

export type PostMyPage = Output<typeof postMyPage>;


export const postPrivateSchema = object({
  ...postTableField.entries,
  private_posts: nullable(optional((privatePosts))),
})


// 編集画面
export const postWithContentDBObject = object({
  ...postTableField.entries,
  user: pubUserModel,
  categories: nullable(optional(array(categoryObject))),
})
export const postWithContentSchema = transformAsync(
  postWithContentDBObject,
  async (input) => {
    const data = await fetch(input.content_path);
    try {
      const json = (await data.json())
      return {
        ...input,
        content: json ? JSON.stringify(json) : "",
        categories: input.categories ? input.categories : [],
        is_liked: false
      };
    } catch (e) {
      return {
        ...input,
        content: "",
        categories: input.categories ? input.categories : [],
        is_liked: false
      };

    }
  }
)


export const postDBObject = object({
  ...postTableField.entries,
  categories: nullable(optional(array(categoryObject))),
})

export const postSchemaWithCategory = transformAsync(postDBObject,
  async (input) => {
    return {
      ...input,
      categories: input.categories ? input.categories : [],
    };
  }
)




//パブリック一覧
export const postDBObjectPub = publicPostTableField

export const postPubSchema = transformAsync(postDBObjectPub,
  async (input) => {
    return {
      ...input,
      categories: input.categories ? input.categories : [],
      is_liked: input.is_liked ?? false
    };
  }
)


export type PostWithPrivate = Output<typeof postPrivateSchema>;
export type PostListItem = Output<typeof postPubSchema>;

//パブリック詳細
export const postDBObjectPubWithContent = object({
  ...publicPostTableField.entries,
  user: pubUserModel,
  is_liked: boolean(),
  categories: (array(categoryObject)),
})

export const postPubSchemaWithContent = transformAsync(postDBObjectPubWithContent,
  async (input) => {
    const data = await fetch(input.content_path);
    try {
      const json = (await data.json())
      return {
        ...input,
        content: json ? JSON.stringify(json) : "",
        is_liked: input.is_liked ?? false,
      };
    } catch (e) {
      return {
        ...input,
        content: "",
        is_liked: input.is_liked ?? false,
      };
    }
  }
)



export type PostPubSchemaWithContentType = Output<typeof postPubSchemaWithContent>;
export type PostSingleWithContentType = Output<typeof postWithContentSchema>;
